import React from 'react';

export default function WishlistHeader() {
  return (
      <div className="hero-image-coll">
        <div className="hero-text-coll">
          <h2>Your List</h2>
        </div>
      </div>
  );
}
